import { render, staticRenderFns } from "./TechProtectionItem.vue?vue&type=template&id=27baf20b&scoped=true&"
import script from "./TechProtectionItem.vue?vue&type=script&lang=js&"
export * from "./TechProtectionItem.vue?vue&type=script&lang=js&"
import style0 from "./TechProtectionItem.vue?vue&type=style&index=0&id=27baf20b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27baf20b",
  null
  
)

export default component.exports